import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { useTranslation } from "@redotech/redo-i18n";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { getLabelPurchaseSkipReasons } from "./label-purchase-selection";

export interface SkippedLabelOrdersProps {
  groups: readonly FulfillmentGroupData[];
}

export const SkippedLabelOrders = memo(function SkippedLabelOrders({
  groups,
}: SkippedLabelOrdersProps) {
  useTranslation();
  return (
    <Flex dir="column" gap="lg">
      {groups.map((group) => (
        <Flex dir="column" gap="xs" key={group._id}>
          <Text fontSize="sm" fontWeight="semibold">
            {group.orders.map((order) => order.name || order.id).join(", ") ||
              group._id}
          </Text>
          {getLabelPurchaseSkipReasons(group).map((reason) => (
            <Text fontSize="sm" key={reason} textColor="error">
              {reason}
            </Text>
          ))}
        </Flex>
      ))}
    </Flex>
  );
});
